import { __assign } from "tslib";
import React from 'react';
import styles from './index.module.less';
import { isString } from '@ekuaibao/helpers';
import EKBIconPark from '../ekbIconPark';
var noop = function () { };
export var TitleWrapperCP = function (props) {
    var topRight = props.topRight, _a = props.showTopBar, showTopBar = _a === void 0 ? true : _a;
    if (!showTopBar) {
        return null;
    }
    return (React.createElement("div", { className: styles['ekb-container-wrapper-top-wrapper'] },
        React.createElement(TitleCP, __assign({}, props)),
        topRight ? topRight : null));
};
export var TitleCP = function (props) {
    var title = props.title, topLeft = props.topLeft, _a = props.showTitleDivider, showTitleDivider = _a === void 0 ? true : _a, showBackArrow = props.showBackArrow, _b = props.onBackClick, onBackClick = _b === void 0 ? noop : _b;
    return (React.createElement("div", { className: styles['ekb-container-wrapper-top-wrapper-left'] },
        showBackArrow ? React.createElement(TitleBack, { onBackClick: onBackClick }) : null,
        isString(title) ? (React.createElement("div", { className: 'title-wrapper' },
            React.createElement("div", { className: "title" }, i18n.get(title)),
            showTitleDivider ? React.createElement("div", { className: "line" }) : null)) : (title),
        topLeft ? topLeft : null));
};
export var TitleBack = function (props) {
    var _a = props.onBackClick, onBackClick = _a === void 0 ? noop : _a;
    return (React.createElement(EKBIconPark, { name: "arrow-left", onClick: onBackClick, style: { marginRight: '10px', color: 'rgba(20, 34, 52, 0.92)', cursor: 'pointer' } }));
};
